import { ItemSourceGuesserItemStatus } from 'constants/itemSourceGuesserStatus';

export function itemSourceGuesserItemStatusRenderer(params: { value?: any }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = parseInt(params.value);

  switch (status) {
    case ItemSourceGuesserItemStatus.PENDING:
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';
    case ItemSourceGuesserItemStatus.NEEDS_USER_REVIEW:
      return '<span class="fa fa-user" style="color: #2196f3;" title="Needs User Review"></span>';
    case ItemSourceGuesserItemStatus.DONE:
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Done"></span>';
    default:
      return '';
  }
}

